export default "__VITE_ASSET__BDZm$jN7__"